import { render } from "./FloatSocialDock.vue?vue&type=template&id=4c076d3d&scoped=true"
import script from "./FloatSocialDock.vue?vue&type=script&lang=js"
export * from "./FloatSocialDock.vue?vue&type=script&lang=js"

import "./FloatSocialDock.vue?vue&type=style&index=0&id=4c076d3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c076d3d"]])

export default __exports__